import React, { useEffect, useState } from "react";
import API from "../../../services/api";

import {
    Gift,
    Target,
    CheckCircle
} from "lucide-react";

import "./IncentiveCard.css";

function IncentiveCard() {

    const [incentives, setIncentives] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        fetchIncentives();

    }, []);

    const fetchIncentives = async () => {

        try {

            const response = await API.get(
                "/delivery/earnings/incentives"
            );

            if (response.data.success) {

                setIncentives(response.data.incentives);

            }

        }

        catch (error) {

            console.log(error);

        }

        finally {

            setLoading(false);

        }

    };

    if (loading) {

        return <p>Loading Incentives...</p>;

    }

    return (

        <div className="incentive-section">

            <div className="section-title">

                <h2>Incentives & Rewards</h2>

            </div>

            {

                incentives.map((item,index)=>{

                    const percent=Math.min(

                        (item.completed/item.target)*100,

                        100

                    );

                    return(

                        <div
                            key={index}
                            className="incentive-card"
                        >

                            <div className="incentive-top">

                                <div className="gift-icon">

                                    <Gift size={22}/>

                                </div>

                                <div>

                                    <h3>

                                        Earn ₹{item.reward}

                                    </h3>

                                    <p>

                                        Complete {item.target} Orders

                                    </p>

                                </div>

                            </div>

                            <div className="progress-info">

                                <span>

                                    <Target size={15}/>

                                    {item.completed}/{item.target}

                                </span>

                                {

                                    item.achieved &&

                                    <span className="completed">

                                        <CheckCircle size={15}/>

                                        Achieved

                                    </span>

                                }

                            </div>

                            <div className="progress-bar">

                                <div

                                    className="progress-fill"

                                    style={{

                                        width:`${percent}%`

                                    }}

                                />

                            </div>

                        </div>

                    );

                })

            }

        </div>

    );

}

export default IncentiveCard;